import axios from 'axios';
import serviceHelper from '../../helpers/functions/service.helper';

async function getMenus(query){
    const queryString = serviceHelper.queryString(query);
    const menuResponse = await axios.get(`affiliate/menu/get?${queryString}`, { withCredentials : true });
    return menuResponse?.data;
}

export default {
    getMenus,
}